import './index.css'

const MoneyDetails = props => {
  const {incomeAmount, expenseAmount, balance} = props
  return (
    <div className="money-details-container">
      <div className="your-balance">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/balance-image.png"
          alt="balance"
          className="money-details-img"
        />
        <div>
          <h1 className="money-details-head">Your Balance</h1>
          <span className="money-details-para">Rs {balance}</span>
        </div>
      </div>
      <div className="your-income">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/income-image.png"
          alt="income"
          className="money-details-img"
        />
        <div>
          <h1 className="money-details-head">Your Income</h1>
          <span className="money-details-para">Rs {incomeAmount}</span>
        </div>
      </div>
      <div className="your-expenses">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/expenses-image.png"
          alt="expense"
          className="money-details-img"
        />
        <div>
          <h1 className="money-details-head">Your Expenses</h1>
          <span className="money-details-para">Rs {expenseAmount}</span>
        </div>
      </div>
    </div>
  )
}

export default MoneyDetails
